export const emotions = [
  { base: 'hapiness.svg', label: 'emotions.hapiness' },
  { base: 'surprise.svg', label: 'emotions.surprise' },
  { base: 'fear.svg', label: 'emotions.fear' },
  { base: 'sadness.svg', label: 'emotions.sadness' },
  { base: 'anger.svg', label: 'emotions.anger' },
  { base: 'disgust.svg', label: 'emotions.disgust' },
];
